import { useEffect, useState } from "react";
import * as yup from "yup";
import { useSelector } from "react-redux";
import ApiCustom from "../../utils/ApiCustom";
import { toast } from "react-toastify";
import ConfirmModal from "../ConfirmModal.js";

const schema = yup.object().shape({
  fullName: yup.string().required("Họ tên người tham gia là bắt buộc"),
  email: yup.string().email("Email không hợp lệ"),
  //   phoneNumber: yup
  //     .string()
  //     .matches(/^[0-9]{10,11}$/, "Số điện thoại không hợp lệ"),
  // .required("Số điện thoại là bắt buộc"),
  companyId: yup.string().required("Tài khoản không thuộc về hội viên nào"),
  postId: yup.string().required("Vui lòng chọn bài viết"),
});

const BusinessForm = ({ noti, isRegistedEvent, sendIsRegistedStatus }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: localStorage.getItem("full_name"),
    email: localStorage.getItem("userEmail") || "",
    phoneNumber: localStorage.getItem("userPhone") || "",
    companyId: JSON.parse(localStorage.getItem("companyId") || ""),
    postId: noti?.id || "",
  });

  useEffect(() => {
    setFormData({ ...formData, postId: noti?.id || "" });
  }, [noti]);

  const [errors, setErrors] = useState({});
  const [isOpenModal, setIsOpenModal] = useState(false);

  const handleCloseModal = () => {
    setIsOpenModal(false);
  };

  const { partners } = useSelector((state) => state.partners);
  const posts = useSelector((state) =>
    state.posts.posts?.filter((p) => p.type === "notification")
  );

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: undefined });
  };

  const createRegistration = async () => {
    let data = {
      companyId: formData.companyId,
      postId: formData.postId,
      fullName: formData.fullName,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
    };

    await ApiCustom({
      method: "post",
      url: "eventRegistration-create",
      data: data,
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        toast(res.data.message || "Đăng ký thành công", { type: "success" });

        setFormData({
          fullName: "",
          email: "",
          phoneNumber: "",
          companyId: "",
          postId: "",
        });
      })
      .catch((error) => {
        console.log(error);
        if (error.response?.status === 422) {
          toast.error(Object.values(error.response?.data?.messages)[0]);
        }
      });
  };
  const handleSubmit = async () => {
    // e.preventDefault();
    setLoading(true);

    try {
      // await schema.validate(formData, { abortEarly: false });

      await createRegistration();
      sendIsRegistedStatus(true);
      handleCloseModal();

      setErrors({});
    } catch (error) {
      if (error.inner) {
        const formErrors = {};
        error.inner.forEach((err) => {
          formErrors[err.path] = err.message;
        });

        toast.error(formErrors.companyId);
      } else {
        toast.error("Đã xảy ra lỗi");
      }
    } finally {
      handleCloseModal();
      setLoading(false);
    }
  };

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          setIsOpenModal(true);
        }}
        className="space-y-4"
      >
        <div className="form-control hidden">
          <label className="text-sm mb-1">
            Họ tên người tham gia<i className="text-red-600"> *</i>
          </label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            className="input input-bordered w-full"
            placeholder="Họ tên người tham gia"
          />
          <p className="text-red-500 text-xs">{errors.fullName}</p>
        </div>

        <div className="form-control hidden">
          <label className="text-sm mb-1">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="input input-bordered w-full"
            placeholder="Email"
          />
          <p className="text-red-500 text-xs">{errors.email}</p>
        </div>

        <div className="form-control hidden">
          <label className="text-sm mb-1">Số điện thoại</label>
          <input
            type="text"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            className="input input-bordered w-full"
            placeholder="Số điện thoại"
          />
          <p className="text-red-500 text-xs">{errors.phoneNumber}</p>
        </div>

        <div className="form-control hidden">
          <label className="text-sm mb-1">
            Đơn vị<i className="text-red-600"> *</i>
          </label>
          <select
            name="companyId"
            value={formData.companyId}
            onChange={handleChange}
            className="select select-bordered w-full"
          >
            <option value="">Chọn đơn vị</option>
            {partners?.map((company) => (
              <option key={company.id} value={company.id}>
                {company.companyName}
              </option>
            ))}
          </select>
          <p className="text-red-500 text-xs">{errors.companyId}</p>
        </div>

        <div className="form-control hidden">
          <label className="text-sm mb-1">
            Chọn hoạt động tham gia<i className="text-red-600"> *</i>
          </label>
          <select
            name="postId"
            value={formData.postId}
            onChange={handleChange}
            className="select select-bordered w-full"
          >
            <option value="">Chọn hoạt động</option>
            {posts.map((post) => (
              <option key={post.id} value={post.id}>
                {post.title}
              </option>
            ))}
          </select>
          <p className="text-red-500 text-xs">{errors.postId}</p>
        </div>

        <button
          type="submit"
          className="btn btn-warning w-full"
          disabled={loading || isRegistedEvent}
        >
          {loading ? (
            <span className="loading loading-spinner"></span>
          ) : !isRegistedEvent ? (
            "Đăng ký tham gia"
          ) : (
            "Đã đăng ký tham gia"
          )}
        </button>
      </form>

      <ConfirmModal
        isOpen={isOpenModal}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        message={"Bạn có chắc chắn muốn đăng ký tham gia không?"}
      />
    </>
  );
};

export default BusinessForm;
